import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "prevent-route-change"
}
const _hoisted_2 = {
  key: 1,
  class: "card"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorPage = _resolveComponent("ErrorPage")!
  const _component_OKDialog = _resolveComponent("OKDialog")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Splitter = _resolveComponent("Splitter")!
  const _component_login_page = _resolveComponent("login-page")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ErrorPage),
    _createVNode(_component_OKDialog),
    (_ctx.preventRouteChange)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.developmentMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.appSessionKeyInStore)
            ? (_openBlock(), _createBlock(_component_Splitter, {
                key: 0,
                style: {"height":"800px"},
                class: "p-mb-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SplitterPanel, { size: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Menu, {
                        class: "myMenu",
                        model: _ctx.menuItems
                      }, null, 8, ["model"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SplitterPanel, { size: 90 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.appSessionKeyInStore)
            ? (_openBlock(), _createBlock(_component_login_page, { key: 1 }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 2 })),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}